export const setBets = (bets) => {
  return {
    type: "SET_BETS",
    payload: bets,
  };
};
